import { axios } from '../utils/http'

// 活动列表
export const getActivityList = (params) => axios(params, '/activity/list')

// 活动详情
export const getActivityDetail = (params) => axios(params, '/activity/detail')


///////
//列表
export const newslist = (params) => axios(params, '/capp/informationHw/list')

//详情
export const newsdetail = (params) => axios(params, '/capp/informationHw/detail')



// WEBPACK FOOTER //
// ./src/api/activity.js